import * as ng from 'angular';
import {ArchiSmallServices} from '../../../services/archismall.service';

class ConfermaController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$timeout',
    '$uibModalStack'
  ];

  private close: any;
  private dismiss: any;

  constructor(
    private $scope: any,
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService,
    private $modalStack: ng.ui.bootstrap.IModalStackService
  ) {
    $scope.updateInProgress = true;
    $scope.updateWithError = false;

    if ($scope.$parent.$resolve.listiniUpdate) {
      ArchiSmallServices.deleteListino($scope.$parent.$resolve.listino._id)
        .then((res) => {
          $timeout(() => {
            $scope.updateInProgress = false;
            $modalStack.getTop().value.keyboard = true;
            $modalStack.getTop().value.backdrop = true;
          }, 2000);
        }, (error) => {
          $rootScope.alert('error', error);
          $scope.cancel();
        });
    } else if ($scope.$parent.$resolve.otherUpdate) {

      ArchiSmallServices.updateOtherUser($scope.$parent.$resolve.user._id, $scope.$parent.$resolve.user, $scope.$parent.$resolve.diffs)
        .then((response) => {
          $timeout(() => {
            $scope.updateInProgress = false;
            $modalStack.getTop().value.keyboard = true;
            $modalStack.getTop().value.backdrop = true;
          }, 2000);
        }, (error) => {
          $rootScope.alert('error', error);
          $scope.cancel();
        });
    } else {

      ArchiSmallServices.updateUser($scope.$parent.$resolve.user)
        .then((response) => {
          $timeout(() => {
            $scope.updateInProgress = false;
            $modalStack.getTop().value.keyboard = true;
            $modalStack.getTop().value.backdrop = true;
          }, 2000);
        }, (error) => {
          $rootScope.alert('error', error);
          $scope.cancel();
        });
    }


    $scope.ok = () => {
      this.close();
    };
    $scope.cancel = () => {
      this.dismiss({$value: 'cancel'});
    };
  }
}

export const ConfermaComponent: ng.IComponentOptions = {
  template: require('./conferma.html'),
  controller: ConfermaController,
  bindings: {
    close: '&',
    dismiss: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/conferma/conferma.ts